import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';


export default function SurveySync() {
  const { t } = useTranslation();
  const image01 = useDocImage('sync-img', 'sync-1.png');
  const image02 = useDocImage('sync-img', 'sync-2.png');
  const image03 = useDocImage('sync-img', 'sync-3.png');
  const image04 = useDocImage('sync-img', 'sync-4.png');
  const image05 = useDocImage('sync-img', 'sync-5.png');

  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Survey Sync Documentation Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>

              <h1 className='mt-0 text-primary'>{t('documentation.surveySync.title')}</h1>
              <p className='header-para'>{t('documentation.surveySync.intro')}</p>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.surveySync.syncFromUat.title')}
                </div>
                <div className="card-body">
                  <p dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.syncFromUat.whenToUse') }}></p>
                   <img src={image01} alt={t('documentation.surveySync.syncFromUat.imageAlt')} className='pb-20 pt-20 mt-1' />
                  <p><b>{t('documentation.surveySync.syncFromUat.stepsTitle')}</b></p>
                  
                  <ul>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.syncFromUat.steps.step1') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.syncFromUat.steps.step2') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.syncFromUat.steps.step3') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.syncFromUat.steps.step4') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.syncFromUat.steps.step5') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.syncFromUat.steps.step6') }}></li>
                  </ul>

                  <p className='alert alert-info mt-3 mb-0'>
                    {t('documentation.surveySync.syncFromUat.note')}
                  </p>
                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.surveySync.fullReplacement.title')}
                </div>
                <div className="card-body">
                  <p dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.fullReplacement.whenToUse') }}></p>
                   <img src={image02} alt={t('documentation.surveySync.fullReplacement.imageAlt')} className='pb-20 pt-20 mt-1' />
                  <p><b>{t('documentation.surveySync.fullReplacement.stepsTitle')}</b></p>
                  <ul>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.fullReplacement.steps.step1') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.fullReplacement.steps.step2') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.fullReplacement.steps.step3') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.fullReplacement.steps.step4') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.fullReplacement.steps.step5') }}></li>
                  </ul>

                  <p><b>{t('documentation.surveySync.fullReplacement.safetyTitle')}</b></p>
                  <ul>
                    <li>{t('documentation.surveySync.fullReplacement.safety.backup')}</li>
                    <li>{t('documentation.surveySync.fullReplacement.safety.responses')}</li>
                    <li>{t('documentation.surveySync.fullReplacement.safety.rollback')}</li>
                  </ul>
                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                 {t('documentation.surveySync.mergeSync.title')}
                </div>
                <div className="card-body">
                  <p dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.mergeSync.whenToUse') }}></p>
                  
                  <p><b>{t('documentation.surveySync.mergeSync.stepsTitle')}</b></p>
                  <ul>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.mergeSync.steps.step1') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.mergeSync.steps.step2') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.mergeSync.steps.step3') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.mergeSync.steps.step4') }}></li>
                     <img src={image03} alt={t('documentation.surveySync.mergeSync.imageAlt1')} className='pb-20 pt-20 mt-1' />
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.mergeSync.steps.step5') }}></li>
                  
                    <li>{t('documentation.surveySync.mergeSync.steps.step6')}
                      <ul>
                        <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.mergeSync.previewItems.newItems') }}></li>
                        <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.mergeSync.previewItems.conflicts') }}></li>
                        <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.mergeSync.previewItems.duplicates') }}></li>
                      </ul>
                    </li>
                      <img src={image04} alt={t('documentation.surveySync.mergeSync.imageAlt2')} className='pb-20 pt-20 mt-1' />
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.mergeSync.steps.step7') }}></li>
                  </ul>

                  <p><b>{t('documentation.surveySync.mergeSync.safetyTitle')}</b></p>
                  <ul>
                    <li>{t('documentation.surveySync.mergeSync.safety.preview')}</li>
                    <li>{t('documentation.surveySync.mergeSync.safety.backup')}</li>
                    <li>{t('documentation.surveySync.mergeSync.safety.atomic')}</li>
                    <li>{t('documentation.surveySync.mergeSync.safety.preserved')}</li>
                  </ul>

                   <h6><b>{t('documentation.surveySync.mergeSync.noChangesTitle')}</b></h6>
                  <p dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.mergeSync.noChangesDesc') }}></p>
                  <ul>
                    <li>{t('documentation.surveySync.mergeSync.noChangesItems.identical')}</li>
                    <li>{t('documentation.surveySync.mergeSync.noChangesItems.noNew')}</li>
                    <li>{t('documentation.surveySync.mergeSync.noChangesItems.safe')}</li>
                  </ul>

                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.surveySync.versionHistory.title')}
                </div>
                <div className="card-body">
                  <p>{t('documentation.surveySync.versionHistory.intro')}</p>
                  
                  <p><b>{t('documentation.surveySync.versionHistory.accessTitle')}</b></p>
                  <ul>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.versionHistory.accessSteps.step1') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.versionHistory.accessSteps.step2') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.versionHistory.accessSteps.step3') }}></li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.versionHistory.accessSteps.step4') }}></li>
                  </ul>
                  <img src={image05} alt={t('documentation.surveySync.versionHistory.imageAlt')} className='pb-20 pt-20 mt-1' />
                  
                  <h6><b>{t('documentation.surveySync.versionHistory.rollbackTitle')}</b></h6>
                  <ol>
                    <li>{t('documentation.surveySync.versionHistory.rollbackSteps.step1')}</li>
                    <li>{t('documentation.surveySync.versionHistory.rollbackSteps.step2')}</li>
                    <li dangerouslySetInnerHTML={{ __html: t('documentation.surveySync.versionHistory.rollbackSteps.step3') }}></li>
                    <li>{t('documentation.surveySync.versionHistory.rollbackSteps.step4')}
                      <ul>
                        <li>{t('documentation.surveySync.versionHistory.rollbackSteps.step4Items.backup')}</li>
                        <li>{t('documentation.surveySync.versionHistory.rollbackSteps.step4Items.restore')}</li>
                        <li>{t('documentation.surveySync.versionHistory.rollbackSteps.step4Items.maintain')}</li>
                      </ul>
                    </li>
                    <li>{t('documentation.surveySync.versionHistory.rollbackSteps.step5')} <br />
                      <b>{t('documentation.surveySync.versionHistory.rollbackSteps.step5Message')}</b><br />
                      {/* <img src={image011} alt="Restore Success Message" className='img-fluid pt-10 pb-20' /> */}
                    </li>
                    <li>{t('documentation.surveySync.versionHistory.rollbackSteps.step6')}</li>
                  </ol>


                  <p className='alert alert-warning mb-0'>{t('documentation.surveySync.versionHistory.note')}</p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  )
}
